import * as React from "react";

//
export const TAB_ORDER_ENABLED = "tabOrderEnabled";
export const TAB_ORDER_REMOVED = "tabOrderRemoved";

// Ids

type Id = string;
type TypeId = Id;
export type DroppableId = Id;
export type DraggableId = Id;

// Droppable

export interface DroppableProvided {
    innerRef: string | ((instance: HTMLDivElement | null) => void) | React.RefObject<HTMLDivElement> | null | undefined;
    placeholder?: React.ReactNode;
    droppableProps?: IDroppableProps;
}

export interface DroppableStateSnapshot {
    isDraggingOver: boolean;
    draggingOverWith?: DraggableId;
    draggingFromThisWith?: DraggableId;
}

// Do we have the prefix "I" here because we're overriding the type file?
interface IDroppableProps {
    droppableId: DroppableId;
    type?: TypeId;
    isDropDisabled?: boolean;
    direction?: "vertical" | "horizontal";
    children: (provided: DroppableProvided, snapshot: DroppableStateSnapshot) => React.ReactElement<any>;
}

export interface WidgetType {
    id: string;
    icon: string;
}

export interface DraggableItemAction {
	iconEnabled: string;
	iconDisabled: string;
	enabled: boolean;
    type: string;
    isActionDisabled: boolean;
}

export interface TabOrderWidget {
    id: string;
    description: string;
    icon: string;
    actions?: DraggableItemAction[];
}

export interface DNDLocation {
    droppableId: string;
    index: number;
}

export interface DNDResult {
    draggableId: string;
    type: string;
    reason: string;
    source: DNDLocation;
    destination?: DNDLocation;
}



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/toolbox/TabOrder/TabOrderDndTypes.ts